export default __webpack_public_path__ + "static/Acta-Bold-ca4f6f3c31e900bb30bfb111711220bc.woff2";